import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=6373e31b&scoped=true&"
import script from "./SignupForm.vue?vue&type=script&lang=js&"
export * from "./SignupForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=6373e31b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373e31b",
  null
  
)

export default component.exports